<template>
  <div  style="background-color: white; color: black;padding: .2rem .2rem 0 .2rem;border-radius: .2rem;margin-top: .2rem;">
    <h5>接机信息</h5>
    <yd-button type="primary" @click.native="contactsShow = true" class="add">添加参会人</yd-button>
    <yd-cell-group>
      <yd-cell-item type="label" v-if="ExhJieji.exhJiejiRel">
        <div slot="left">历史接机人</div>
        <div slot="right">
          <div v-for="(rel,index) in ExhJieji.exhJiejiRel" :key="index">
            {{rel.contact.user_name}} ~ {{rel.contact.mobile_phone}}
          </div>
        </div>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group>
      <yd-cell-item type="label" class="pick_up">
        <div slot="left">是否接机</div>
        <yd-switch slot="right" v-model="ExhJieji.is_jie"></yd-switch>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group title="接机站">
      <yd-cell-item type="radio" v-for="(zhan, index) of JiejiZhan" :key="index">
        <span slot="left">{{zhan}}</span>
        <input slot="right" type="radio" :value="index" @click="jiejiTime(index)" v-model="ExhJieji.jieji_zhan"/>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group title="接机时间">
      <yd-cell-item type="radio" v-for="(time, index) of JiejiTime" :key="index">
        <span slot="left">{{time}}</span>
        <input slot="right" type="radio" :value="index" v-model="ExhJieji.jieji_time"/>
      </yd-cell-item>
    </yd-cell-group>
    <yd-cell-group>
      <yd-cell-item>
        <span slot="left">到达时间：</span>
        <input slot="right" v-model="ExhJieji.jieji_daodatime" placeholder="到达时间">
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">所乘车次（航班）：</span>
        <input slot="right" v-model="ExhJieji.jieji_checi" placeholder="所乘车次（航班）">
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">备注：</span>
        <input slot="right" v-model="ExhJieji.jieji_beizhu" placeholder="备注说明">
      </yd-cell-item>
    </yd-cell-group>
    <div v-if="songji">
      <yd-cell-group>
        <yd-cell-item type="label" class="pick_up">
          <div slot="left">是否送机</div>
          <yd-switch slot="right" v-model="ExhJieji.is_song"></yd-switch>
        </yd-cell-item>
      </yd-cell-group>
      <yd-cell-group title="送机站">
        <yd-cell-item type="radio" v-for="(zhan, index) of SongjiZhan" :key="index">
          <span slot="left">{{zhan}}</span>
          <input slot="right" type="radio" :value="index" @click="chufaTime(index)" v-model="ExhJieji.song_zhan"/>
        </yd-cell-item>
      </yd-cell-group>
      <yd-cell-group title="出发时间">
        <yd-cell-item type="radio" v-for="(time, index) of ChufaTime" :key="index">
          <span slot="left">{{time}}</span>
          <input slot="right" type="radio" :value="index" v-model="ExhJieji.song_time"/>
        </yd-cell-item>
      </yd-cell-group>
      <yd-cell-group>
        <yd-cell-item>
          <span slot="left">出发时间：</span>
          <input slot="right" v-model="ExhJieji.songji_chufatime" placeholder="出发时间">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">所乘车次（航班）：</span>
          <input slot="right" v-model="ExhJieji.songji_checi" placeholder="所乘车次（航班）">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left">备注：</span>
          <input slot="right" v-model="ExhJieji.song_beizhu" placeholder="如果不在正常时间请备注说明">
        </yd-cell-item>
      </yd-cell-group>
    </div>
    <yd-button size="large" type="primary" @click.native="submitJieji()" v-preventReClick>提交</yd-button>
    <yd-popup v-model="contactsShow" position="center" width="90%">
      <div style="background-color:#fff;">
        <yd-checklist align="right" v-model="contactsCheckList" :callback="change">
          <yd-checklist-item v-for="(contacts,index) of contactsList" :key="index" :val="contacts.id" >
            <div style="height: 50px;line-height: 50px;">{{contacts.user_name}}</div>
          </yd-checklist-item>
        </yd-checklist>
        <p style="text-align: center;" v-if="contactsList.length === 0">已全部添加</p>
        <p style="text-align: center;margin-top: 0.2rem">
          <yd-button @click.native="contactsShow = false">确定</yd-button>
        </p>
      </div>
    </yd-popup>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      MeetList: [],
      contactsCheckList: [],
      contactsList: [],
      JiejiZhan: {},
      SongjiZhan: {},
      songji: false,
      JiejiTime: {},
      ChufaTime: {},
      ExhJieji: {
        is_jie: 0,
        is_zijia: 0,
        is_song: 0,
        jieji_zhan: '',
        jieji_time: '',
        song_zhan: '',
        song_time: '',
        jieji_beizhu: '',
        song_beizhu: '',
        jieji_daodatime: '',
        jieji_checi: '',
        songji_chufatime: '',
        songji_checi: '',
        fair_id: this.$route.params.id,
        business_id: localStorage.getItem('uid')
      },
      ExhJiejiRel: [],
      contactsShow: false,
      params: this.$route.params
    }
  },
  methods: {
    change (value, isCheckAll) {
      this.isCheckAll = isCheckAll
    },
    getContacts () {
      let that = this
      let data = {uid: this.$store.state.uid, fairid: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/user/meeting-contacts', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.contactsList = res.data
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getJiejiZhan () {
      let that = this
      let data = {type: 'jiezhan', fair_id: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/jieji', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.JiejiZhan = res.data
            this.getMeetView()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getMeetView () {
      let that = this
      let data = {uid: this.$store.state.uid, fair_id: this.params.id, id: this.params.meet_id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/meetveiw', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.ExhJieji = res.data
            this.ExhJieji.is_jie = this.ExhJieji.is_jie === '是' ? true : false
            this.ExhJieji.is_song = this.ExhJieji.is_song === '是' ? true : false
            this.ExhJieji.is_zijia = this.ExhJieji.is_zijia === '是' ? true : false
            this.ExhJieji.exhJiejiRel.forEach(rel => {
              this.ExhJiejiRel.push({contacts_id: [rel.contacts_id]})
            })
            // this.checkTime()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getSongjiZhan () {
      let that = this
      let data = {type: 'songzhan', fair_id: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/jieji', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.SongjiZhan = res.data
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkAll () {
      this.isCheckAll = !this.isCheckAll
      this.$refs.checklistDemo.$emit('ydui.checklist.checkall', this.isCheckAll)
    },
    HistoryBack () {
      window.history.back()
    },
    jiejiTime (zhan) {
      let that = this
      let data = {type: 'jiezhantime', fair_id: this.params.id, zhan: zhan}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/jieji', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.JiejiTime = res.data
            this.ExhJieji.jieji_time = ''
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },

    chufaTime (zhan) {
      let that = this
      let data = {type: 'songzhantime', fair_id: this.params.id, zhan: zhan}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/jieji', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.ChufaTime = res.data
            this.ExhJieji.song_time = ''
          }
        })
        .catch(function (res) {
          // localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    // checkTime () { // todo 默认时间选择
    //   console.log(this.ExhJieji)
    //   console.log(this.JiejiZhan)
    //   console.log(this.SongjiZhan)
    //   this.JiejiZhan.forEach((zhan, index) => {
    //     if (this.Exhjieji.jieji_zhan === zhan) {
    //       this.jiejiTime(index)
    //     }
    //   })
    //   this.SongjiZhan.forEach((zhan, index) => {
    //     if (this.Exhjieji.song_zhan === zhan) {
    //       this.ChufaTime(index)
    //     }
    //   })
    // },
    getSetting () {
      let that = this
      let data = {type_: 'is_songji', fair_id: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/user/setting', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.songji = true
            this.getSongjiZhan()
          }
          this.getJiejiZhan()
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkJieji () {
      if (this.ExhJieji.is_jie) {
        if (this.ExhJieji.jieji_zhan === '') {
          this.$dialog.toast({
            mes: '请选择接机站'
          })
          return false
        } else {
          if (this.ExhJieji.jieji_time === '') {
            this.$dialog.toast({
              mes: '请选择接机时间'
            })
            return false
          }
        }
      }
      if (this.ExhJieji.is_song) {
        if (this.ExhJieji.song_zhan === '') {
          this.$dialog.toast({
            mes: '请选择送机站'
          })
          return false
        } else {
          if (this.ExhJieji.songji_chufatime === '') {
            this.$dialog.toast({
              mes: '请选择送机时间'
            })
            return false
          }
        }
      }
      if (this.ExhJieji.is_jie === false && this.ExhJieji.is_song === false) {
        this.$dialog.toast({
          mes: '接机送机至少选择一个'
        })
        return false
      }
      return true
    },
    submitJieji () {
      if (this.checkJieji() === false) {
        return false
      }
      this.ExhJieji.is_jie = this.ExhJieji.is_jie ? '是' : '否'
      this.ExhJieji.is_song = this.ExhJieji.is_song ? '是' : '否'
      this.ExhJieji.is_zijia = this.ExhJieji.is_zijia ? '是' : '否'
      let ExhJiejiRel = []
      this.contactsCheckList.forEach(contact => {
        ExhJiejiRel.push({contacts_id: [contact]})
      })
      let data = {}
      if (ExhJiejiRel.length > 0) {
        data = {
          ExhJieji: this.ExhJieji,
          ExhJiejiRel: ExhJiejiRel,
          id: this.params.meet_id
        }
      } else {
        data = {
          ExhJieji: this.ExhJieji,
          ExhJiejiRel: this.ExhJiejiRel,
          id: this.params.meet_id
        }
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/fair/meetupdate', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.$dialog.toast({
              mes: '修改接机信息成功'
            })
            this.$router.push({path: '/' + this.params.id + '/puck-up'})
          } else {
            this.$dialog.toast({
              mes: res.msg
            })
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getSetting()
    this.getContacts()
  }
}
</script>

<style lang="stylus" scoped>
  h5
    padding-left: .3rem
  .pick_up::before
    content: ""
    width: .14rem
    height: .14rem
    background-color: #00c800
    position: absolute
    top: calc(50% - .14rem)
    left: .0rem
    margin-top: .06rem
  .add
    width: 1.2rem
    left: .24rem
    margin-top: .2rem

  .yd-cell-item>:last-child>:nth-child(2)::after
    display: none!important
</style>



// WEBPACK FOOTER //
// src/views/template1/MeetUpdate.vue